import React, { FC } from 'react';
import cn from 'classnames';
import parse from 'html-react-parser';

import { cleanBuilderParagraphInput, getBuilderString } from '@/shared/text';

import { TextLot } from './types';
import style from './TextItem.module.scss';
import { Action } from '../Action';

interface Props {
  locale: string;
  item: TextLot;
}

export const TextItem: FC<Props> = ({ locale, item }) => (
  <article className={style.textItem}>
    <div className={cn(style.card, 'u-border')}>
      <div
        className={cn(style.content, 'u-p-h-xl', 'tw:flex', 'tw:items-center')}
      >
        <div>
          {parse(
            cleanBuilderParagraphInput(getBuilderString(item.text, locale))
          )}
        </div>
      </div>
    </div>
    <Action
      className={cn(style.action)}
      locale={locale}
      label={item.actionLabel}
      url={item.actionUrl}
      variant={item.actionVariant}
    />
  </article>
);
